import { ClipboardAccountIcon } from './ClipboardAccountIcon';

/**
 * author: Google
 * id C45D118E-4FFA-42E5-A18B-B8A7B58BF42F
 * name clipboard-account
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-account.svg
 * tags
 * - Account / User 
 */
export const ClipboardPersonIcon = ClipboardAccountIcon;
export default ClipboardPersonIcon